module.exports = __webpack_public_path__ + "img/025.b9dc7a75.jpg";